import { Table } from "react-bootstrap";
import { useState, useContext, useEffect } from "react";
import "../components/Reminder.css";
import { UserDataContext } from "../components/UserDataContext";
import Button from "@mui/material/Button";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";

export default function DataTable({ data = [], onUpdate, buttonAll }) {
  const { userData } = useContext(UserDataContext);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

  const sortedData = Array.isArray(data)
    ? [...data].sort((a, b) => {
        if (sortConfig.key === null) return 0;
        const direction = sortConfig.direction === "asc" ? 1 : -1;

        if (a[sortConfig.key] < b[sortConfig.key]) {
          return -1 * direction;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return 1 * direction;
        }
        return 0;
      })
    : [];

  const requestSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  return (
    <div>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th className="td-centered" onClick={() => requestSort("id")}>
              ID
            </th>

            <th onClick={() => requestSort("content")}>Opis dnia</th>
            <th
              style={{ width: "10%" }}
              onClick={() => requestSort("datatask")}
            >
              Data
            </th>
            <th style={{ width: "10%" }}>Dodaj fotkę</th>
          </tr>
        </thead>
        <tbody>
          {sortedData.map((item, index) => (
            <tr key={index}>
              <td data-label="ID">{index + 1}</td>
              <td data-label="Opis dnia">{item.description}</td>
              <td data-label="Data">{item.dateday}</td>
              <td data-label="Data">
                <Button variant="contained">
                  <AddAPhotoIcon></AddAPhotoIcon>
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}
